import Money from 'assets/Icons/Sidebar/Money'
import { DateInput, Label, TextInput } from 'components/Form'
import { Modal, Tooltip } from 'components/Overlay'
import notification from 'helpers/notification'
import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import services from 'services/index'

const Payment = ({ data, getGroupById }) => {
	const params = useParams()
	const { id } = params
	const [visible, setVisible] = useState(false)
	const [paymentData, setPaymentData] = useState({ date: '', amount: null })
	const { first_name, last_name, name } = data
	const payment = () => {
		const options = {
			data: { ...paymentData, group: id, student: data?.id },
			onError: () => notification('Error', { type: 'error' }),
			onSuccess: response => {
				if (response?.status === 201) {
					getGroupById(id)
					notification("To'lov ma'umotlari saqlandi!", {
						type: 'success',
					})
					setVisible(false)
				} else {
					notification('Error', { type: 'error' })
				}
			},
		}
		services.groups.paymentStudent(options)
	}
	return (
		<div>
			<div className='flex justify-center sm:justify-start items-center'>
				<Tooltip title="To'lov qilish" distance={6}>
					<button className='edit-icon' onClick={() => setVisible(true)}>
						<Money />
					</button>
				</Tooltip>
			</div>
			<Modal
				maxWidth='800px'
				onClose={() => setVisible(false)}
				onOpen={() => setVisible(true)}
				open={visible}
			>
				<div className='p-6'>
					<h1 className='text-[18px] lg:text-[24px] text-[#292A32] dark:text-[#ffffff] font-semibold mb-4'>
						To'lov qilish
					</h1>
					<div className='grid grid-cols-12 gap-6'>
						<div className='col-span-12 sm:col-span-6'>
							<Label>Ism-familiya</Label>
							<TextInput
								value={first_name + ' ' + last_name}
								isDisabled={true}
							/>
						</div>
						<div className='col-span-12 sm:col-span-6'>
							<Label>Guruh</Label>
							<TextInput value={name} isDisabled={true} />
						</div>
						<div className='col-span-12 sm:col-span-6'>
							<Label>To'lov sanasi</Label>
							<DateInput
								value={paymentData?.date}
								onChange={date => setPaymentData({ ...paymentData, date })}
							/>
						</div>
						<div className='col-span-12 sm:col-span-6'>
							<Label>To'lov summasi</Label>
							<TextInput
								value={paymentData?.amount}
								onChange={amount => setPaymentData({ ...paymentData, amount })}
							/>
						</div>
					</div>
					<div className='flex justify-end items-center mt-[24px]'>
						<button
							className='success-btn w-full sm:w-[150px]'
							onClick={payment}
						>
							Saqlash
						</button>
					</div>
				</div>
			</Modal>
		</div>
	)
}

export default Payment
